import {
  React,
  loadable,
  Route,
  Switch,
  BrowserRouter as Router
} from './libraries'
import './App.css'
import { ScrollToTop } from './utils'

const App = () => {
  const Home = loadable(() => import('./pages/home'))
  const Article = loadable(() => import('./pages/article'))
  const DetailArticle = loadable(() => import('./pages/article/detail'))
  const Info = loadable(() => import('./pages/info'))
  const DetailInfo = loadable(() => import('./pages/info/detail'))
  const About = loadable(() => import('./pages/about'))
  const Merchandised = loadable(() => import('./pages/merchandise'))
  const Gallery = loadable(() => import('./pages/gallery'))
  const Registration = loadable(() => import('./pages/register'))
  const Agenda = loadable(() => import('./pages/agenda'))

  return (
    <Router basename='/frontend-fevci'>
      <ScrollToTop />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/article' exact component={Article} />
        <Route path='/detail-article/:slug' exact component={DetailArticle} />
        <Route path='/info' exact component={Info} />
        <Route path='/detail-info/:slug' exact component={DetailInfo} />
        <Route path='/merchandise' exact component={Merchandised} />
        <Route path='/gallery' exact component={Gallery} />
        <Route path='/about' exact component={About} />
        <Route path='/registration' exact component={Registration} />
        <Route path='/agenda' exact component={Agenda} />
      </Switch>
    </Router>
  )
}

export default App
